
import { connect } from 'react-redux';

import ResultList from './ResultList';
import { createBoundedSlider } from './Slider';
import { createBoundedColorSlider } from './ColorSlider';
import { createBoundedCheckboxList, CheckboxItem } from './CheckboxList';

import { resetFilter, setFilter } from '../store';

let SliderHeight = createBoundedSlider("hoehenmeter");
let SliderDistance = createBoundedSlider("distance");
let SliderDuration = createBoundedSlider("time");

let SliderExperience = createBoundedColorSlider("wertung_alpine_erfahrung");
let SliderDifficulty = createBoundedColorSlider("wertung_schwindelfreiheit");
let SliderFitness = createBoundedColorSlider("wertung_alpine_kondition");

let SonnigerWegBox = createBoundedCheckboxList("sonnigerweg")
let KategorieBox = createBoundedCheckboxList("kategorie")
let StatusBox = createBoundedCheckboxList("status")
//let JahreszeitBox = createBoundedCheckboxList("jahreszeit")
let MonthsBox = createBoundedCheckboxList("months")
let LageBox = createBoundedCheckboxList("lage")

let maybe = (cond, children) => {
    return cond ? children : null;
}

function Application(props) {
    let { commonSliders, colorSliders, monthsSelect, categorySelect } = props.config;
    let { kinderwagen } = props;
    let { resetFilter, onChangeFilter } = props;

    console.log("Application kinderwagen", kinderwagen);

    return (

        <div className="alpininfo-app">

            <div className="grid">

                <div className="col col-6">

                    { maybe(commonSliders, <SliderHeight name="hoehenmeter" title="Höhenmeter" unit="m" />) }
                    { maybe(commonSliders, <SliderDistance name="distance" title="Distanz" scale={1000} unit="km" />) }
                    { maybe(commonSliders, <SliderDuration name="time" title="Dauer" unit="h" />) }

                </div>

                <div className="col col-3">
                    { maybe(categorySelect, <KategorieBox />) }
                </div>

                <div className="col col-3">
                    <SonnigerWegBox />
                    <br />
                    <LageBox />
                    <br />
                    <div className="checkbox-group vertical">
                        <CheckboxItem name="Kinderwagen" value="1" checked={kinderwagen} onChange={e => onChangeFilter("kinderwagen", !kinderwagen)} />
                    </div>
                </div>

            </div>

            <div className="grid margin">

                { maybe(colorSliders,
                    <div className="col col-6">
                        <SliderExperience name="wertung_alpine_erfahrung" title="Erfahrung" />
                        <SliderDifficulty name="wertung_schwindelfreiheit" title="Schwindelfreiheit" />
                        <SliderFitness name="wertung_alpine_kondition" title="Kondition" />
                    </div>
                 ) }

                <div className="col col-3">
                    <StatusBox />
                </div>

                <div className="col col-3">
                </div>

            </div>
            <div className="grid margin">

                <div className="col col-10">
                    { maybe(monthsSelect, <MonthsBox horizontal />) }
                </div>

                <div className="col col-2">
                    <button onClick={resetFilter}>Filter zurücksetzen</button>
                </div>

            </div>

            {/*
            <div className="grid margin alpin-tip">

                <div className="col col-2">
                    <img src="static/img/moritz-zobel.jpg" />
                </div>

                <div className="col col-10">
                    <h4>Individueller Tipp vom Alpinberater Moritz Zobel</h4>
                    <p>
                        Im August Gewittergefahr beachten!<br/>
                        Im September Temperaturrückgang beachten.
                        <span className="arrow" />
                    </p>
                </div>

            </div>
            */}

            <div className="results-container">
                <ResultList />
            </div>
        </div>
    )
}


const mapStateToProps = (state) => {
    return {
        config: state.config,
        kinderwagen: (state.filter.kinderwagen || false),
    };
}


const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetFilter: (name, min, max) => {
            dispatch(resetFilter());
        },
        onChangeFilter: (name, new_value) => {
            dispatch(setFilter(name, new_value));
        },
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./components/Application.js